import { ContractContext, ContractUser } from 'ts/common/contract/types';

export const getContractUserType = (
    contractUserEmail: string,
    contractContacts?: SpApi.Client.IContact[]
): ContractUser => {
    return contractUserEmail.toLowerCase() === (contractContacts?.[0]?.email || '').toLowerCase()
        ? 'primaryContact'
        : contractUserEmail.toLowerCase() === (contractContacts?.[1]?.email || '').toLowerCase()
        ? 'secondaryContact'
        : 'studio';
};

export const needsToSign = (
    contractUserEmail: string,
    contractData?: SpApi.IBaseContract,
    context?: ContractContext
): boolean => {
    const isClientContext =
        context === ContractContext.CLIENT_BOOKING_CONTRACT ||
        context === ContractContext.CLIENT_STANDALONE_CONTRACT;
    const contractUser = getContractUserType(contractUserEmail, contractData?.contacts);

    if (contractUser === 'studio') {
        return (
            !isClientContext &&
            contractData?.contractStatus === 'awaiting-studio-countersign' &&
            !contractData?.signatureStudio
        );
    }

    if (contractData?.contractStatus === 'awaiting-client-signature' && isClientContext) {
        const hasSigned = contractData.signatureClients?.some(
            (signature) => signature.signerEmail === contractUserEmail
        );
        return !hasSigned;
    }

    return false;
};
